import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getCohortDataInLocalStorage, setCohortDataInLocalStorage } from './localStorageUtils';
import { getTimestamp, now, startOfMonth, startOfWeek } from 'owa-datetime';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { logUsage } from 'owa-analytics';
import { UserActivityKeys } from '../schema/UserCohortData';
import type { Modules } from 'mini-usercustomproperties/lib/schema/Modules';

/**
 * Updates the user activity data of the user in browser local storage
 * NOTE - used the parameter as appModule instead of module since 'module' is a keyword
 * @param module Module in which the user activity is to be stored in
 */
export const updateUserCohort = async (appModule: Modules, actionName: string) => {
    if (!isMiniFeatureEnabled('mini-cohort-analysis')) {
        return;
    }

    const weekStartDate: number = getTimestamp(startOfWeek(now(), 1));
    const monthStartDate: number = getTimestamp(startOfMonth(now()));

    const userActivities = getCohortDataInLocalStorage();

    const userConfig = getUserConfiguration();

    if (!userActivities[UserActivityKeys.mailboxCreationDate]) {
        userActivities[UserActivityKeys.mailboxCreationDate] = userConfig.MailboxCreateDate;
    }

    if (!userActivities[UserActivityKeys.miniFirstLogonDate]) {
        userActivities[UserActivityKeys.miniFirstLogonDate] =
            userConfig.UserOptions.FirstOWAReactMiniLogon;
    }

    // Update weekly activity
    if (!userActivities[UserActivityKeys.userWeeklyActivity][appModule][weekStartDate]) {
        userActivities[UserActivityKeys.userWeeklyActivity][appModule][weekStartDate] = {};
    }

    if (userActivities[UserActivityKeys.userWeeklyActivity][appModule][weekStartDate][actionName]) {
        userActivities[UserActivityKeys.userWeeklyActivity][appModule][weekStartDate][
            actionName
        ] += 1;
    } else {
        userActivities[UserActivityKeys.userWeeklyActivity][appModule][weekStartDate][
            actionName
        ] = 1;
    }

    // Update monthly activity
    if (!userActivities[UserActivityKeys.userMonthlyActivity][appModule][monthStartDate]) {
        userActivities[UserActivityKeys.userMonthlyActivity][appModule][monthStartDate] = {};
    }

    if (
        userActivities[UserActivityKeys.userMonthlyActivity][appModule][monthStartDate][actionName]
    ) {
        userActivities[UserActivityKeys.userMonthlyActivity][appModule][monthStartDate][
            actionName
        ] += 1;
    } else {
        userActivities[UserActivityKeys.userMonthlyActivity][appModule][monthStartDate][
            actionName
        ] = 1;
    }

    setCohortDataInLocalStorage(userActivities);

    // Log datapoint
    logUsage('MiniCohortAnalysis', { data: JSON.stringify(userActivities) });
};
